import React from "react";

import { MdmDevice, useGetAllDevicesByProjectQuery } from "gql/generated/types";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";

const Devices = () => {
  const projectId = useOutletContext<string>();
  const { data, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const edit = (rowData: MdmDevice) => (
    <Button
      icon="pi pi-info-circle"
      className="p-button-rounded p-button-text"
      onClick={() => navigate(`/devices/${rowData.id}`)}
    />
  );

  const columns: TableColumn<MdmDevice>[] = [
    { field: "identifier", header: "identifier", sortable: true, filter: true },
    { field: "mdmObject", header: "Object Code", sortable: true, filter: true, body: (rowData) => rowData.mdmObject?.title },
    { field: "tags", header: "Tags", body: (rowData) => rowData.tags.join(", ") },
    {
      header: "Actions",
      body: edit,
      style: {
        width: "10%",
      },
    },
  ];
  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmDeviceByProjectId as MdmDevice[] ?? []}
        searchFields={["identifier", "tags"]}
        isLoading={loading}
        onToolbarBtnClick={() => navigate("/devices/new")}
        toolbarBtnLabel="Add Device"
      />
    </div>
  );
};

export default Devices;
